
export const safeSetItem = (key: string, value: string): boolean => {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (e) {
    console.warn(`Storage quota exceeded for key: ${key}`, e);
    if (e instanceof DOMException && (
      e.name === 'QuotaExceededError' ||
      e.name === 'NS_ERROR_DOM_QUOTA_REACHED'
    )) {
      // Try to clear some space or handle it
      return false;
    }
    return false;
  }
};

export const safeGetItem = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    console.error(`Failed to get item from localStorage: ${key}`, e);
    return null;
  }
};

export const safeRemoveItem = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    console.error(`Failed to remove item from localStorage: ${key}`, e);
  }
};

/**
 * Attempts to save a config object, but strips large data if it fails.
 */
export const safeSaveConfig = (key: string, config: any): boolean => {
  const json = JSON.stringify(config);
  if (safeSetItem(key, json)) return true;

  // If it failed, try stripping heavy fields
  console.log("Attempting to save minified config...");
  const minConfig = { ...config };
  
  // List of potentially heavy fields to strip
  const heavyFields = ['userSounds', 'customMelodies', 'fxPresets', 'ballPlacementConfigs', 'spaceSpiralRoundConfigs'];
  
  for (const field of heavyFields) {
    if (minConfig[field]) {
      minConfig[field] = [];
      if (safeSetItem(key, JSON.stringify(minConfig))) {
        console.warn(`Saved config by stripping ${field} to stay within quota.`);
        return true;
      }
    }
  }

  return false;
};
